// redux/importReseller/Types.ts

import { iStateMessage } from '@/customTypes/GenericReduxTypes';

export const REDUCER_NAME = 'importReseller';

export interface IUserRef {
  id: string;
  name: string;
}

export interface IImportResellerItem {
  importStartedAt: string;
  importCompletedAt: string;
  priceIncreasePercent: string;
  totalImportedProducts: number;
  reseller: IUserRef;
  wholesaler: IUserRef;
}

export interface IImportResellerState {
  isLoading: boolean;
  list: IImportResellerItem[];
  error: iStateMessage | null;
}
